<template>
  <div class="osd-field">
    <label class="osd-field__label">{{ label }}</label>
    <div class="osd-field__control">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "OrgSettingsDialogField",
  props: {
    label: { type: String, required: true },
  },
};
</script>
